/**
 * Centralized Z-Index Scale
 * 
 * This file defines the z-index hierarchy for the entire application.
 * Always use these constants instead of hardcoding z-index values.
 * 
 * Usage: 
 *   import { Z_INDEX } from '../utils/zIndexScale';
 *   <div style={{ zIndex: Z_INDEX.ADD_BUTTON_HOVER }} />
 */

export const Z_INDEX = {
  // Base website content (patterns, backgrounds)
  BASE: 0,
  PATTERN: 1,
  PATTERN_OVERLAY: 2,
  
  // Website content
  CONTENT: 10,
  
  // Edit mode base
  EDIT_INDICATOR: 50,           // Selection outlines, indicators
  EDIT_OVERLAY: 60,             // Semi-transparent overlays
  
  // Interactive edit elements
  ADD_BUTTON_BASE: 100,         // Add buttons in normal state
  DRAG_HANDLE: 120,             // Drag handles
  RESIZE_HANDLE: 120,           // Resize handles
  ADD_BUTTON_HOVER: 150,        // Add buttons on hover (must be above content)
  
  // Layout/UI chrome
  DIVIDER: 200,                 // Split pane dividers
  TOOLBAR: 300,                 // Toolbars, navbars in edit mode
  
  // Dropdowns and popovers
  DROPDOWN: 1000,               // Dropdown menus
  POPOVER: 1100,                // Popovers, tooltips
  
  // Modals and overlays
  MODAL_BACKDROP: 5000,         // Modal backdrop/overlay
  MODAL: 5100,                  // Modal content
  MODAL_NESTED: 5200,           // Nested modals (if any)
  
  // Critical overlays
  CROP_TOOL: 8000,              // Image crop overlay
  LOADING_OVERLAY: 9000,        // Loading spinners
  TOAST: 9500,                  // Toast notifications
  
  // Absolute top (use sparingly)
  CRITICAL: 10000,              // Debug overlays, critical alerts
};

/**
 * Helper to get z-index with optional offset
 * 
 * @param {string} key - Key from Z_INDEX object
 * @param {number} offset - Optional offset to add to the base value
 * @returns {number} The z-index value
 * 
 * @example
 * getZIndex('ADD_BUTTON', 5) // Returns 105
 */
export function getZIndex(key, offset = 0) {
  if (!(key in Z_INDEX)) {
    console.warn(`Unknown z-index key: ${key}`);
    return Z_INDEX.CONTENT + offset;
  }
  return Z_INDEX[key] + offset;
}

